import axios from "axios";

import { CategoryApiResponse } from "./categoryApi";
import { API_CALL_URL } from "../constants";

export type SubCategoryApiResponse = {
  id: string;
  subCategoryName: string;
  orderIndex: number;
  icon: string;
  bgColor: string;
  categoryId: string;
  category?: CategoryApiResponse;
  createdAt: Date;
  updatedAt: Date;
};

export type SubCategoryUpsertRequest = {
  id?: string;
  subCategoryName: string;
  orderIndex: number | null;
  bgColor: string | null;
  categoryId: string;
};

export type SubCategoryIconUpsertRequest = {
  id: string;
  icon: string;
};

export const fetchSubCategory = async (): Promise<SubCategoryApiResponse[]> => {
  try {
    const response = await axios.get<SubCategoryApiResponse[]>(`${API_CALL_URL}/sub-category`);
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return [];
  }
};

export const upsertSubCategory = async ({
  id,
  subCategoryName,
  orderIndex,
  bgColor,
  categoryId,
}: SubCategoryUpsertRequest): Promise<SubCategoryApiResponse | undefined> => {
  try {
    const response = await axios.post<SubCategoryApiResponse>(`${API_CALL_URL}/sub-category`, {
      id: id ?? undefined,
      subCategoryName,
      orderIndex,
      bgColor,
      categoryId,
    });
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return undefined;
  }
};

export const deleteSubCategory = async ({ id }: { id: string }): Promise<boolean> => {
  try {
    await axios.delete(`${API_CALL_URL}/sub-category/${id}`);
    return true;
  } catch (error) {
    console.error("Axios error:", error);
    return false;
  }
};

export const upsertSubCategoryIcon = async ({
  id,
  icon,
}: SubCategoryIconUpsertRequest): Promise<SubCategoryApiResponse | undefined> => {
  try {
    const response = await axios.post(`${API_CALL_URL}/sub-category/upsert-icon`, {
      id,
      icon,
    });
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return undefined;
  }
};
